import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IndexedDbService {
  private dbName = 'MedEaseVault';
  private storeName = 'secrets';
  private dbVersion = 1;

  constructor() {}

  private openDb(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = (event) => {
        console.error('Database error:', event);
        reject('Database error');
      };

      request.onsuccess = (event: any) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName); // Key-Value store
        }
      };
    });
  }

  async saveWrappedKey(
    orgId: string,
    wrappedKey: ArrayBuffer,
    salt: ArrayBuffer
  ): Promise<void> {
    const db = await this.openDb();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      // Store items individually or as an object
      store.put(wrappedKey, `wrappedKey_${orgId}`);
      store.put(salt, `salt_${orgId}`);

      transaction.oncomplete = () => resolve();
      transaction.onerror = (e) => reject(e);
    });
  }

  async getWrappedKeyData(orgId: string): Promise<{
    wrappedKey: ArrayBuffer;
    salt: ArrayBuffer;
  } | null> {
    const db = await this.openDb();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);

      const requestKey = store.get(`wrappedKey_${orgId}`);
      const requestSalt = store.get(`salt_${orgId}`);

      transaction.oncomplete = () => {
        if (requestKey.result && requestSalt.result) {
          resolve({
            wrappedKey: requestKey.result,
            salt: requestSalt.result,
          });
        } else {
          resolve(null);
        }
      };
      transaction.onerror = (e) => reject(e);
    });
  }

  async clearStorage(orgId?: string): Promise<void> {
    const db = await this.openDb();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      if (orgId) {
        store.delete(`wrappedKey_${orgId}`);
        store.delete(`salt_${orgId}`);
        transaction.oncomplete = () => resolve();
        transaction.onerror = (e) => reject(e);
      } else {
        const req = store.clear();
        req.onsuccess = () => resolve();
        req.onerror = (e) => reject(e);
      }
    });
  }
}
